module.exports = __webpack_public_path__ + "img/c08_buildingtechhorseshoes_Normal_ua.a2e6f181.webp";